import Vue from 'vue'

const state = {
  access: sessionStorage.access,
  socket: sessionStorage.socket,
  refresh: sessionStorage.refresh,
  setDate: sessionStorage.setDate,
  userID: sessionStorage.userID,
  activeTokens: [],
  activeApiKeys: []
}

const getters = {
  authenticated (state) {
    const isAuthenticated = state.access && state.userID
    return isAuthenticated
  },
  accessToken: (state) => state.access,
  activeTokens: (state) => state.activeTokens,
  userID: (state) => state.userID,
  activeApiKeys: (state) => state.activeApiKeys
}

const actions = {
  async login ({commit}, { email, password, totp }) {
    const {body} = await Vue.http.post('/checkin', {
      email,
      password,
      totp
    })

    commit('setLoginTokens', body.data)
    commit('setUserID', body.data.user)
  },
  async getActiveTokens ({commit}) {
    const {body} = await Vue.http.get('/tokens')
    commit('setActiveTokens', body.data)
  },
  async changePassword ({commit}, {user, password}) {
    await Vue.http.post('/change/password', {
      user,
      password
    })
  },
  async getActiveApiKeys ({commit}) {
    const {body} = await Vue.http.get('/api/keys')
    commit('setActiveApiKeys', body.data)
  },
  async generateApiKey (context, description) {
    const {body} = await Vue.http.post('/generate/key', { description })
    return body.data
  },
  async revokeApiKey (context, id) {
    await Vue.http.delete(`/revoke/key/${id}`)
  },
  async logout ({commit}) {
    await Vue.http.post(`/checkout`)
    commit('revokeAuthentication')
  }
}

const mutations = {
  setLoginTokens (state, tokens) {
    sessionStorage.access = state.access = tokens.access
    sessionStorage.socket = state.socket = tokens.socket
    sessionStorage.refresh = state.refresh = tokens.refresh
    sessionStorage.setDate = state.setDate = new Date()
  },
  setUserID (state, id) {
    sessionStorage.userID = state.userID = id
  },
  setActiveTokens (state, tokens) {
    state.activeTokens = tokens
  },
  setActiveApiKeys (state, keys) {
    state.activeApiKeys = keys
  },
  revokeAuthentication (state) {
    sessionStorage.clear()

    state.access = null
    state.socket = null
    state.refresh = null
    state.setDate = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js